import { Model, belongsTo, hasMany } from 'miragejs';

export default {
  account: Model.extend({
    user_set: hasMany('user'),
    business_phones: hasMany('businessPhone'),
    billing_setting: belongsTo('billingSetting'),
    twilio_configuration: belongsTo('twilioConfiguration'),
  }),
  user: Model.extend({
    account: belongsTo(),
  }),
  industry: Model,
  salesforceAccount: Model,
  callRescueTestCall: Model,
  businessPhone: Model.extend({
    account: belongsTo(),
  }),
  parentAccount: Model,
  billingSetting: Model.extend({
    account: belongsTo(),
  }),
  twilioConfiguration: Model.extend({
    account: belongsTo(),
  }),
};
